import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';


function csrfToken() {
    return (window.Params && window.Params.csrf_token) || '';
}

function translateError(code, message) {
    switch (code) {
        case 'promo-not-found': return 'Промокод не найден';
        case 'promo-expired': return 'Срок действия промокода истёк';
        case 'promo-used': return 'Этот промокод уже использован';
        case 'promo-already': return 'На этом аккаунте уже активирован промокод';
        case 'promo-not-applicable': return 'Промокод не применим — действует только для новых аккаунтов';
        default: return message || code;
    }
}


class PromoCodeDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            busy: false,
            code: '',
            error: '',
            message: '',
            promoUntil: null,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.open && !prevProps.open) {
            this.setState({ loading: true, error: '', message: '' });
            fetch('/admin/rest/promo/status', {
                credentials: 'same-origin',
                headers: { 'X-CSRF-Token': csrfToken() },
            })
                .then(r => r.json())
                .then(json => {
                    this.setState({ loading: false, promoUntil: json.promo_until || null });
                })
                .catch(() => this.setState({ loading: false }));
        }
    }

    handleActivate() {
        const code = this.state.code.trim();
        if (!code) {
            this.setState({ error: 'Введите промокод' });
            return;
        }
        this.setState({ busy: true, error: '', message: '' });
        fetch('/admin/rest/promo/activate', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken(),
            },
            body: JSON.stringify({ code }),
        })
            .then(r => r.json())
            .then(json => {
                if (json.status === 'ok') {
                    this.setState({
                        busy: false,
                        message: json.message,
                        code: '',
                        promoUntil: json.promo_until,
                    });
                } else {
                    this.setState({
                        busy: false,
                        error: translateError(json.code, json.message),
                    });
                }
            })
            .catch(err => this.setState({ busy: false, error: err.message }));
    }

    render() {
        const { open, onClose } = this.props;
        const { loading, busy, code, error, message, promoUntil } = this.state;

        return (
            <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
                <DialogTitle>Промокод</DialogTitle>
                <DialogContent>
                    {loading && <CircularProgress size={24} />}
                    {!loading && promoUntil && new Date(promoUntil) > new Date() &&
                        <Typography variant="body2" style={{ marginBottom: 16, color: '#2e7d32' }}>
                            Активирован промокод до {new Date(promoUntil).toLocaleDateString('ru-RU')}.
                        </Typography>
                    }
                    {!loading &&
                        <>
                            <TextField
                                label="Введите промокод"
                                value={code}
                                onChange={e => this.setState({ code: e.target.value.toUpperCase(), error: '' })}
                                fullWidth
                                margin="normal"
                                disabled={busy}
                            />
                            {error && <Typography color="error" variant="body2">{error}</Typography>}
                            {message && <Typography variant="body2" style={{ color: '#2e7d32', marginTop: 8 }}>{message}</Typography>}
                        </>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Закрыть</Button>
                    <Button onClick={this.handleActivate.bind(this)}
                            color="primary"
                            variant="contained"
                            disabled={busy || loading}>
                        {busy ? <CircularProgress size={20} /> : 'Активировать'}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default PromoCodeDialog;
